import React from 'react';

/**
 * POSHeader - Search bar + branding.
 */
const POSHeader = ({ searchQuery, onSearchChange, salonName, staffName }) => {
  return (
    <div className="pos-header">
      <div className="pos-search-wrap">
        <svg className="pos-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          className="pos-search-input"
          type="text"
          placeholder="Search products, services, or scan barcode..."
          value={searchQuery}
          onChange={e => onSearchChange(e.target.value)}
        />
        {searchQuery && (
          <button className="pos-search-clear" onClick={() => onSearchChange('')}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#8e8e93" strokeWidth="1.6" strokeLinecap="round">
              <line x1="3" y1="3" x2="11" y2="11" /><line x1="11" y1="3" x2="3" y2="11" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default POSHeader;
